(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lp-ar-preview"] && !Shopify.designMode) return;
  try {
    (() => {
  const isIOS = /iPhone|iPad|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  const isAndroid = /Android/.test(navigator.userAgent);
  const productUrl = location.origin + location.pathname;
  const prepare = link => {
    const arBase = link.dataset.lpArBase;
    const modelVersion = link.dataset.lpArVersion || '';
    if (!arBase) return;
    if (isIOS) {
      link.setAttribute('rel', 'ar');
      link.href = arBase + 'model.usdz' + modelVersion + '#allowsContentScaling=0&canonicalWebPageURL=' + encodeURIComponent(productUrl);
    } else if (isAndroid) {
      link.href = 'intent://arvr.google.com/scene-viewer/1.0?file=' + encodeURIComponent(arBase + 'model.glb' + modelVersion) + '&mode=ar_only&resizable=false&title=' + encodeURIComponent(document.title) + '#Intent;scheme=https;package=com.google.ar.core;action=android.intent.action.VIEW;S.browser_fallback_url=' + encodeURIComponent(productUrl) + ';end;';
    }
  };
  const setup = () => {
    document.querySelectorAll('[data-lp-ar-preview]').forEach(prepare);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, { once: true });
  else setup();
  document.addEventListener('click', event => {
    const preview = event.target.closest('[data-lp-ar-preview]');
    if (preview) {
      prepare(preview);
      if (!isIOS && !isAndroid) {
        event.preventDefault();
        const dialog = [...document.querySelectorAll('[data-lp-ar-dialog]')].find(node => node.dataset.lpArDialog === preview.dataset.lpArPreview);
        if (dialog && !dialog.open) dialog.showModal();
      }
    }
    const close = event.target.closest('[data-lp-ar-close]');
    if (close) close.closest('dialog')?.close();
  });
})();
  } catch(e) { console.error(e); }
})();

})();
